import { Paper, TableContainer } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * ScrollableTableContainer
 *
 * Standard wrapper for MUI tables that should horizontally scroll when the viewport shrinks.
 * Centralizing this avoids repeating overflow/border-radius tweaks across many list pages.
 */
export const ScrollableTableContainer = ({
  children,
  variant = 'outlined',
  borderRadius = 2,
  component = Paper,
  sx,
  overflowY = 'hidden',
}) => {
  const isPaper = component === Paper
  return (
    <TableContainer
      component={component}
      variant={isPaper ? variant : undefined}
      sx={{
        borderRadius: isPaper ? borderRadius : undefined,
        overflowX: 'auto',
        overflowY,
        ...sx,
      }}
    >
      {children}
    </TableContainer>
  )
}

ScrollableTableContainer.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
  borderRadius: PropTypes.number,
  component: PropTypes.any,
  sx: PropTypes.object,
  overflowY: PropTypes.string,
}

ScrollableTableContainer.displayName = 'ScrollableTableContainer'

